import React from 'react';
import { NavLink } from 'react-router-dom';
import './NavMenu.scss';

const NavMenu = ({ handleClick, showClass }) => {
  return (
    <div className={`navigation__menu ${showClass}`}>
      <NavLink
        className='nav-link'
        onClick={handleClick}
        to="/"
      >
        Home
      </NavLink>
      <NavLink
        className='nav-link'
        onClick={handleClick}
        to="/house-of-arie-one"
      >
        House of Arie 1
      </NavLink>
      <NavLink
        className='nav-link'
        onClick={handleClick}
        to="/house-of-arie-Two"
      >House of Arie 2
      </NavLink>
      <NavLink
        className='nav-link'
        onClick={handleClick}
        to="/about"
      >
        About Us
      </NavLink>
      <NavLink
        className='nav-link'
        onClick={handleClick}
        to="/contact"
      >
        Contact Us
      </NavLink>
    </div>
  )
};

export default NavMenu;
